/* eslint-disable */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Transition } from 'react-transition-group'
import styled from '@emotion/styled'
import { css } from 'emotion'

const StyledOverlayContext = css`
  width: 100vw;
  height: 100vh;
  display: block;
  overflow-y: auto;
  position: fixed;
  top: 0;
  left: 0;
  text-align: center;
  z-index: 10;

  &:before {
    content: '';
    display: inline-block;
    height: 100vh;
    vertical-align: middle;
  }
`

const StyledOverlayContextCover = styled('div')`
  width: 100%;
  height: 100%;
  background: rgba(71, 104, 130, 0.5);
  position: absolute;
  top: 0;
  left: 0;
  transition: opacity 300ms ease-out;
  z-index: 0;
`

export const StyledOverlayContextContent = styled('div')`
  display: inline-block;
  position: relative;
  text-align: initial;
  transition: all 300ms ease-out;
  vertical-align: middle;
`

const transitions = {
  entering: css`
    opacity: 0;
    transform: translateY(50px);
  `,
  entered: css`
    opacity: 1;
    transform: translateY(0);
  `,
  exiting: css`
    opacity: 0;
    transform: translateY(-100%);
  `,
}

const overlayTransitions = {
  entering: css`
    opacity: 0;
  `,
  entered: css`
    opacity: 1;
  `,
  exiting: css`
    opacity: 0;
  `,
}

export default class OverlayContext extends Component {
  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.element])
      .isRequired,
    className: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    show: PropTypes.bool,
  }

  componentDidMount() {
    document.addEventListener('keyup', this.handleEscKey)
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.handleEscKey)
  }

  handleEscKey = e => {
    e.keyCode == 27 && this.props.onClose()
  }

  render() {
    const { className, show } = this.props

    return (
      <Transition in={show} timeout={300} mountOnEnter unmountOnExit>
        {status => (
          <div className={`${StyledOverlayContext} ${className || ''}`}>
            <StyledOverlayContextCover
              className={overlayTransitions[status]}
              onClick={this.props.onClose}
            />
            <StyledOverlayContextContent className={transitions[status]}>
              {this.props.children}
            </StyledOverlayContextContent>
          </div>
        )}
      </Transition>
    )
  }
}
